export const pipelineData = ({ modelPipeline }, { modelId }) =>
  modelPipeline.byId[modelId];

export const selectedChart = ({ modelPipeline }) =>
  modelPipeline && modelPipeline.selectedChart;

export const advancedChartIsSelected = ({ modelPipeline }) =>
  Boolean(modelPipeline && modelPipeline.selectedChart === 'advanced');
